import { render } from "./EmptyLayoutComponent.vue?vue&type=template&id=6f323ffc"
const script = {}

import exportComponent from "C:\\Sistemas\\CredenciamentoSUS\\aplicacao\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__